Customer.Dashboard ||= {}

class Customer.Dashboard.TicketHistoryEventView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/header/ticket_history_event']
  className: 'conversation-event'


  initialize: ({@event}) ->

  render: ->
    event_message = @event.message()
    return unless event_message
    @$el.html @template
      user: @event.get('user')
      eventTime: Date.create(@event.created_at()).format 'hh:mm:ss A - DD MMM YYYY'
      message: event_message
    @
